<template>
  <PopWrap
    ref="shortAnswerPopWrap"
    :btnText="btnStatus"
    :disabled="btnDiasbaled"
    @clicked="handleBtnClick"
  >
    <template v-slot:title>
      <div class="title-wrap">
        <div class="title-label flex items-center text-motif-font-100">
          <img class="title-icon mr-1" src="./assets/icon-text.svg" alt="" />
          简答题
        </div>
        <div class="title-content">
          {{ content.title }}
        </div>
      </div>
    </template>
    <div class="answer-content">
      <textarea
        ref="textarea"
        v-model.trim="text"
        :disabled="submitted"
        :placeholder="placeholder"
        class="textarea"
      ></textarea>
      <label class="textarea-border"></label>
    </div>
    <ShortAnswerAnalysis v-if="isAnalysisShow" :analysis="content.analysis" class="anlysis-wrap" />
  </PopWrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Prop, Component } from 'vue-property-decorator';
import PopWrap from '../VideoPopWrap';
import ShortAnswerAnalysis from '../VideoCommon/VideoPopAnalysis.vue';

@Component({
  components: {
    PopWrap,
    ShortAnswerAnalysis
  }
})
export default class VideoShortAnswer extends Vue {
  @Prop({ type: Object }) content!: Content & {
    title: string;
    placeholder?: string;
    analysis?: string;
    answer?: string;
  };
  @Prop() isInLookBack!: boolean;
  text = '';
  disabled = false;
  submitted = false;
  isFocus = false;
  scrollTimer: number | null = null;
  startTime: number;

  get placeholder() {
    return this.content.placeholder || '请输入内容...';
  }

  get btnDiasbaled() {
    return (
      this.text.length === 0 || (this.submitted && !this.content.analysis && !this.isInLookBack)
    );
  }

  get btnStatus() {
    if (this.isInLookBack) return '继续';
    return this.submitted && this.content.analysis ? '继续' : '确定';
  }

  get isAnalysisShow() {
    return this.content.analysis && this.submitted;
  }

  scrollToBottom() {
    const wrap = this.$refs.shortAnswerPopWrap as PopWrap;
    wrap.scrollToBottom();
  }

  handleBtnClick() {
    if (this.submitted) {
      this.loadNext();
    } else {
      window.storyteller.updateAssignContent({
        $id: this.content.$id,
        $kind: this.content.$kind,
        ...{
          answer: this.text
        }
      });

      this.trackShortAnswer();

      this.$Message.success({
        time: 1800,
        content: '提交成功'
      });
      this.submitted = true;

      if (!this.content.analysis) {
        this.loadNext(true);
      } else {
        this.scrollTimer = window.setTimeout(() => {
          this.scrollToBottom();
        }, 200);
      }
    }
  }

  trackShortAnswer() {
    const duration = new Date().getTime() - this.startTime;
    console.log(new Date().getTime(), this.startTime, duration);
    window.$tracker?.tracker?.shortAnswerSubmit({
      resource_id: this.content.$id,
      next_resource_id: '',
      content: this.text,
      score: 0,
      duration: new Date().getTime() - this.startTime,
      title: this.content.title
    });
  }

  loadNext(delay?: boolean) {
    if (delay) {
      setTimeout(() => {
        this.$emit('next');
      }, 2000);
    } else {
      this.$emit('next');
    }
  }

  beforeDestroy() {
    this.scrollTimer && clearTimeout(this.scrollTimer);
  }

  mounted() {
    this.startTime = new Date().getTime();
    if (this.content.answer) {
      this.submitted = true;
      this.text = this.content.answer;
      if (!this.content.analysis && !this.isInLookBack) {
        this.loadNext(true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-wrap {
  padding: 5px 20px 20px;
}
.title-label {
  height: 20px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}
.title-icon {
  width: 14px;
}
.title-content {
  @apply text-motif-font-400 font-medium;
  font-size: 16px;
  line-height: 22px;
}
.answer-content {
  @apply relative w-full;
  z-index: 1;
  padding-top: 12px;
}
.textarea {
  @apply w-full ring-0 resize-none block bg-transparent pt-0;
  height: 134px;
  color: #2b3439;
  font-size: 14px;
  line-height: 22px;
  border: 0;
  outline: none !important;
}
.textarea:disabled {
  color: #2b3439 !important;
  -webkit-text-fill-color: #2b3439;
  opacity: 1; /* required on iOS */
}

.textarea-border {
  @apply absolute left-0 top-0 right-0 bottom-0 rounded-md;
  z-index: -1;
  border: 1px solid #e8e9eb;
}

.textarea:focus + .textarea-border {
  border-color: #9e82ec;
}

.anlysis-wrap {
  margin-top: 20px;
}
</style>
